var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template-download"},[_c('h5',[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"btns"},[_c('el-button',{attrs:{"loading":_vm.loading,"disabled":_vm.url ? false : true,"size":"mini"},on:{"click":function($event){return _vm.onDownLoad()}}},[_vm._v("下载模板")]),_c('p',{staticClass:"tips"},[_vm._v(_vm._s(_vm.tips))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }